import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../../ui-components/molecules/tag/tag";
import { getStatusColor } from "../../../services/pickups";
import { Popover } from "ui-components/popover/popover";
import { formatToMMDD } from "features/freights/utils/utils";
import XGSNavLink from "ui-components/xgs-nav-link/xgsNavLink";

const columnHelper = createColumnHelper<any>();

export const getOutboundInboundInhouseColumns = (handlePickupClick: (p: any) => void) => [
  columnHelper.accessor("type", {
    header: "Type",
    size: 120,
    cell: info => info.getValue(),
  }),

  columnHelper.accessor("pickupNumber", {
    header: "Pickup#",
    size: 100,
    cell: info => info.getValue() ? <div className="blue-link" onClick={() => handlePickupClick(info.getValue())}>{info.getValue()}</div> : '-',
  }),

  columnHelper.accessor("probillNumber", {
    header: "Probill Number",
    size: 100,
    cell: info => <XGSNavLink
      className="xgs-table-link-cell"
      to={`/shipments/${info.getValue()}`}
    >
      {info.getValue()}
    </XGSNavLink>
  }),

  columnHelper.accessor(
    row => {
      const city = row.consigneeCity;
      const state = row.consigneeState;

      if (!city && !state) return '-';
      if (city && state) return `${city}, ${state}`;
      return city || state;
    },
    {
      id: "consigneeCityState",
      header: "Consignee City, State",
      size: 140,
      minSize: 140,
      enableSorting: false,
      cell: info => info.getValue(),
    }
  ),

  columnHelper.accessor("shipperName", {
    header: "Shipper",
    size: 200,
    cell: info => {
      const { shipperName, shipperAccountNumber } = info.row.original;

      return (
        <div>
          <span>{shipperName || "—"}</span> {' '}
          {shipperAccountNumber && (
            <span className="xgs-inbound-pickups__table__label">
              {shipperAccountNumber}
            </span>
          )}
        </div>
      );
    },
  }),

  columnHelper.accessor("destinationServiceCenter", {
    header: () => (
      <>
        Destination Terminal  <Popover values={<div className="drivers-sidebar__tooltip">Indicates the terminal context relevant to the next planning action.</div>} />
      </>
    ),
    size: 160,
    cell: info => {
      const value = info.getValue();
      if (!value) return null;

      return (
        <>
          {value.airportCode} - {value.terminalName?.toUpperCase()}
          <span style={{ color: "rgba(79, 95, 114, 0.72)" }}>
            {" "} {value.terminalNumber}
          </span>
        </>
      );
    },
  }),
  columnHelper.accessor("items", {
    header: "Items",
    size: 60,
  }),

  columnHelper.accessor("weight", {
    header: "Weight (lbs)",
    size: 80,
    cell: info => info.getValue()?.toLocaleString(),
  }),

  columnHelper.accessor("trailerNumber",
    {
      id: "trailerNumber",
      header: "Trailer",
      size: 90,
      cell: ({ getValue }) => getValue() ?? '-',
    }
  ),

  columnHelper.accessor("driverName", {
    id: "driverName",
    header: "Driver",
    size: 110,
    cell: info => info.getValue() ?? '-',
  }),

  columnHelper.accessor("eta", {
    header: "ETA",
    size: 60,
    cell: info => info.getValue() ? <div>{formatToMMDD(info.getValue())}</div> : '-',
  }),

  columnHelper.accessor("manifestNumber", {
    header: "Manifest",
    size: 90,
    cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
  }),

  columnHelper.accessor("status", {
    header: "Status",
    size: 190,
    minSize: 100,
    cell: info => (
      info.getValue() ? <Tag mods={{ color: getStatusColor(info.getValue()), uppercase: true }}>
        {info.getValue()}
      </Tag> : ""
    ),
  }),
];
